import React from 'react'
import AutoForm from '@components/AutoForm'
import Button from '@components/Button'
import useRef from '@hooks/useRef'
import useWebsiteId from '@hooks/useWebsiteId'
import formatNumber from '@i18n/formatNumber'
import NumberField from '@packages/justo-parts/lib/components/fields/numeral/Number'
import {useTranslation} from 'next-i18next'
import {Field, WithValue} from 'simple-react-form'

import styles from './styles.module.css'

export default function Form(props) {
  const {me, config, setRedeeming} = props
  const {name, multipleOf} = config
  const websiteId = useWebsiteId()
  const button = useRef()
  const {t} = useTranslation('website', {keyPrefix: 'redeem.redeem.form'})

  const initalAmount = multipleOf ? me.balance - (me.balance % multipleOf) : me.balance
  return (
    <div className={styles.container}>
      <br />
      <AutoForm
        doc={{websiteId, amount: initalAmount}}
        mutation="redeemPoints"
        buttonRef={button}
        onSuccess={coupon => (window.location.href = `/pedir?cupon=${coupon.code}`)}>
        <div className="label">{t('labelHowManyRedeem', {name})}</div>
        <Field fieldName="amount" type={NumberField} />

        <WithValue>
          {({amount}) => (
            <div>{t('labelCreateCoupon', {amount: formatNumber(amount, 'money')})}</div>
          )}
        </WithValue>

        <br />
        <div className={styles.disclaimer}>{t('labelNotRevertRedemptions', {name})}</div>
        <div className={styles.disclaimer}>{t('labelOnlyOneCouponPerPurchase')}</div>
        {multipleOf ? (
          <div className={styles.disclaimer}>
            {t('labelAmountMultipleOf', {money: formatNumber(multipleOf, 'money')})}
          </div>
        ) : null}
      </AutoForm>
      <br />
      <Button onClick={() => setRedeeming(false)}>{t('labelCancel')}</Button>
      <Button primary ref={button}>
        {t('labelRedeemAndCreateCoupon')}
      </Button>
    </div>
  )
}
